import { del, get, patch } from './http.ts';
import type { Device, UsageDetail } from './types.ts';

export const listDevices = (): Promise<{ items: Device[] }> => get('/devices');

export const renameDevice = (id: string, name: string): Promise<{ ok: boolean }> =>
  patch(`/devices/${id}`, { name });

export const setExcludedPaths = (id: string, paths: string[]): Promise<{ ok: boolean }> =>
  patch(`/devices/${id}`, { excluded_paths: paths });

export const revokeDevice = (id: string): Promise<{ ok: boolean }> => del(`/devices/${id}`);

export const usage = (): Promise<UsageDetail> => get('/usage');
